<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
			@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close>
			<template #default>
				<el-form ref="form" :model="form" label-width="80px" size="mini">
					<el-form-item label="分组名称">
						<el-input v-model="form.shopName" clearable></el-input>
					</el-form-item>
					<el-form-item label="父级" >
						<el-select v-model="form.parentid" clearable>
							<el-option v-for="(item,index) in parentdata" :key="index" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="管理员">
						<staff v-model="form.adminstaffid" @modalsubmit="staffsubmit" clearable />
					</el-form-item>
				</el-form>
			</template>
			<template #footer>
				<vxe-button status="primary" content="确认" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import staff from '@_system/components/formcomponents/common/select/staff/select.vue'
	export default {
		mixins: [listMixins, modalMixins],
		props: {
			nodeid: {
				default: () => {
					return 0
				}
			},
			currentItem: {
				default: () => {
					return null
				}
			},
			sourceoperatedata: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				parentdata:[],
				modal_title: '新增分组',
				modal_width: 600,
				modal_height: 'auto',
				form: {
					shopName: '',
					parentid: 0,
					adminstaffid: null
				}
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {
			
		},
		mounted() {
			
		},
		methods: {
			modal_onshow(){
				this.parentdata = this.sourceoperatedata.filter((item)=>{
					return item.id !=this.nodeid
				})
				this.form = {
					shopName: '',
					parentid: 0,
					adminstaffid: null
				}
				if(this.currentItem){
					if(this.nodeid){
						for(let i in this.form){
							this.form[i] = this.currentItem[i]
						}
					}else{
						this.form.parentid = this.currentItem.id
					}
				}
				
			},
			staffsubmit(e){
				this.form.adminstaffid = e.data
			
			},
			submit() {
				this.form.parentid = Math.max(0,this.form.parentid)
				if(!this.nodeid){
					this.$api.BIshopgoods.addgroup(this.form).then(()=>{
						this.modal_cancel()
						this.$message.success('操作成功')
						this.$emit('addsuccess')
					})
				}else{
					this.form.id = this.nodeid
					this.$api.BIshopgoods.addgroup(this.form).then(()=>{
						this.modal_cancel()
						this.$message.success('操作成功')
						this.$emit('addsuccess')
					})
				}
			},
			reset() {
				//this.init()
			}
		},
		components: {
			staff
		}
	}
</script>